import React, { useState, useEffect, useRef } from "react";
import InputSymptom from "./Component/InputSymtom";
import SymptomQuestions from "./Component/SymptomQuestions";
import DiagnosisResults from "./Component/DiagnosisResults";
import knowledgeBase from "./Component/knowledgeBase";
import SpecialistRecommendations from "./Component/specialistsData";
import TopHeader from "../../components/common/Header/TopHeader";

const SymptomAssistant = () => {
    const [selectedSymptoms, setSelectedSymptoms] = useState([]);
    const [tempAnswers, setTempAnswers] = useState({}); // respuestas en progreso
    const [finalAnswers, setFinalAnswers] = useState(null);
    const [detectedDiseases, setDetectedDiseases] = useState([]);

    // Ref para saber el tamaño previo de la lista de síntomas
    const prevSymptomsLength = useRef(0);

    // Función que se pasa a InputSymptom
    const handleSymptomsChange = (newSymptoms) => {
        // Si la lista disminuye (síntoma eliminado), limpiamos resultados
        if (newSymptoms.length < prevSymptomsLength.current) {
            setFinalAnswers(null);
            setDetectedDiseases([]);
        }
        prevSymptomsLength.current = newSymptoms.length;
        setSelectedSymptoms(newSymptoms);
    };

    return (
        <main id="app">
            <TopHeader />
        <div
            style={{
                display: "flex",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    backgroundColor: "white",
                    padding: "20px 40px 40px 40px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    borderRadius: "12px",
                    width: "70%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "30px",
                }}
            >
                <InputSymptom onSymptomsChange={handleSymptomsChange} />

                <SymptomQuestions
                    symptoms={selectedSymptoms}
                    onFinish={setTempAnswers}
                    onComplete={(answers) => {
                        setFinalAnswers(answers);
                    }}
                />

                {finalAnswers && (
                    <DiagnosisResults
                        answers={finalAnswers}
                        onDiseasesDetected={setDetectedDiseases}
                    />
                )}

                {detectedDiseases.length > 0 && (
                    <SpecialistRecommendations
                        diseases={detectedDiseases}
                        knowledgeBase={knowledgeBase}
                    />
                )}
            </div>
        </div>
        </main>
    );
};

export default SymptomAssistant;
